import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import API_BASE_URL from "../../../../Constants";

const ViewInvoiceModal = ({ open, handleClose, invoiceId }) => {
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchInvoice = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/invoice/${invoiceId}`);

      if (!response.ok) {
        throw new Error('Error fetching invoice');
      }

      const data = await response.json();
      setInvoice(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching invoice:", error);
      setInvoice(null);
      setLoading(false);
    }
  };


  useEffect(() => {
    if (open && invoiceId) {
      fetchInvoice();
    }
  }, [open, invoiceId]);

  if (!open) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle>View Invoice</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Typography>Loading...</Typography>
        ) : invoice ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Invoice Details */}
            <div className="border border-gray-300 rounded-lg p-4">
              <Typography variant="h6">Invoice Details</Typography>
              <Typography variant="body1">
                <strong>Invoice Number:</strong> {invoice.invoiceNumber || "N/A"}
              </Typography>
              <Typography variant="body1">
                <strong>Invoice Date:</strong> {invoice.invoiceDate || "N/A"}
              </Typography>
              <Typography variant="body1">
                <strong>Customer:</strong> {invoice.customer || "N/A"}
              </Typography>
              <Typography variant="body1">
                <strong>Building ID:</strong> {invoice.buildingID || "N/A"}
              </Typography>
              <Typography variant="body1">
                <strong>Address:</strong> {invoice.addressOne || "N/A"}{" "}
                {invoice.addressTwo || ""}
              </Typography>
            </div>

            {/* Financial Details */}
            <div className="border border-gray-300 rounded-lg p-4">
              <Typography variant="h6">Financial Details</Typography>
              <Typography variant="body1">
                <strong>Invoice Amount:</strong> {invoice.invoiceAmount.toFixed(2) || "N/A"}
              </Typography>
              <Typography variant="body1">
                <strong>Parts Amount:</strong> {invoice.partsAmount.toFixed(2) || "N/A"}
              </Typography>
              <Typography variant="body1">
                <strong>Discount Amount:</strong> {invoice.discountAmount.toFixed(2) || "N/A"}
              </Typography>
              <Typography variant="body1">
                <strong>Tax Amount:</strong> {invoice.taxAmount.toFixed(2) || "N/A"}
              </Typography>
              <Typography variant="body1">
                <strong>Status:</strong> {invoice.isOpen ? "Open" : "Closed"}
              </Typography>
            </div>
          </div>
        ) : (
          <Typography>No invoice details available.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewInvoiceModal;